// import { View } from "native-base"
// import React, { useCallback, useImperativeHandle, useRef, useState } from "react"
// import { Portal } from "react-native-alves-portal"
// import { useAppContext } from "../../../Universal/API/Context-API/AppContext"
// import { heightOfTopNav } from "../TopNavigator"
// import Animated, { Easing, RollOutRight, runOnJS, useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated"
// import { verticalScale_ } from "../../../Universal/API/Scale"
// import { config, handleExpandedMenu, TOP_NAV_COLOR } from "./utils"
// import { StyleSheet } from "react-native"
// import BackDrop, { handleBackDrop } from "../../../Universal/searchBars/Components/BackDrop"


// const ExpandedMenu:React.FC<any> = React.forwardRef<handleExpandedMenu, any>(({}, ref) => {

//     const {isSmallVersion} = useAppContext()


//     const height = useSharedValue(0)

//     const animatedStyle = useAnimatedStyle(() => ({
//         height: height.value
//     }))

//     const [guts, setGuts] = useState(null)
//     const [exapnded, setExpanded] = useState(false)

//     const refBackDrop = useRef<handleBackDrop>(null)

//     const expand = () => {
//         refBackDrop.current?.setStart(true)
//         setExpanded(true)
//     }
//     const close_with_back_drop = () => {
//         refBackDrop.current?.setStart(false)
//         setExpanded(false)
//     }
//     const open = useCallback(() => {
//         height.value = withTiming(
//              config.EXPANDED_HEIGHT, 
//              config.expandConfig,
//              () => {
//                 runOnJS(expand)()
//              }
//         )
//     },[expand])

//     const close = useCallback(() => {
//         close_with_back_drop()
//          height.value = withTiming(
//              config.HIDDEN_HEIGHT, 
//              config.closeConfig,
//         )
//     }, [close_with_back_drop])


//     useImperativeHandle(ref, () => ({
//         open,
//         close,
//         setGuts,
//         openClose: (props) => {
//             if(props){
//                 setGuts(props)
//             }
//             if(height.value > 0){
//                 close()
//             }else{
//                 open()
//             }
//         }
//     }))

//     const top =  heightOfTopNav(isSmallVersion)
//     return (
//         <Portal>
            
//             {<View style={[StyleSheet.absoluteFill,  {top, left: 0, right: 0,}] }>
//                 <BackDrop
//                 ref={refBackDrop}
//                 onPress={close}/>
//                 </View>}
//             <Animated.View 
//             style={[{position: 'absolute',
//                 zIndex: 300,
//                 left: 0, right: 0,top, backgroundColor: TOP_NAV_COLOR}, 
//                 animatedStyle
//             ]}>
//                 {exapnded && guts}
//             </Animated.View>
//         </Portal>
//     )
// })

// export default ExpandedMenu

import { View } from "native-base";
import React, { useCallback, useImperativeHandle, useRef, useState } from "react";
import { Portal } from "react-native-alves-portal";
import { useAppContext } from "../../../Universal/API/Context-API/AppContext";
import { heightOfTopNav } from "../TopNavigator";
import Animated, {
  runOnJS,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import { config, handleExpandedMenu, TOP_NAV_COLOR } from "./utils";
import { StyleSheet } from "react-native";
import BackDrop, { handleBackDrop } from "../../../Universal/searchBars/Components/BackDrop";

const ExpandedMenu: React.FC<any> = React.forwardRef<handleExpandedMenu, any>(({}, ref) => {
  const { isSmallVersion } = useAppContext();

  const height = useSharedValue(0);

  const animatedStyle = useAnimatedStyle(() => ({
    height: height.value,
  }));

  const [guts, setGuts] = useState<React.ReactNode>(null);
  const [expanded, setExpanded] = useState(false);

  const refBackDrop = useRef<handleBackDrop>(null);

  // ✅ JS-safe state (без чтения height.value)
  const isOpenRef = useRef(false);
  const isAnimatingRef = useRef(false);

  const jsOpenUI = useCallback(() => {
    refBackDrop.current?.setStart(true);
    setExpanded(true);
    isOpenRef.current = true;
    isAnimatingRef.current = false;
  }, []);

  const jsCloseUI = useCallback(() => {
    // закрываем backdrop
    refBackDrop.current?.setStart(false);

    // ✅ IMPORTANT: чистим контент только после close-анимации
    setExpanded(false);
    setGuts(null);

    isOpenRef.current = false;
    isAnimatingRef.current = false;
  }, []);

  const open = useCallback(() => {
    if (isOpenRef.current || isAnimatingRef.current) return;

    isAnimatingRef.current = true;

    height.value = withTiming(config.EXPANDED_HEIGHT, config.expandConfig, (finished) => {
      if (finished) runOnJS(jsOpenUI)();
      else runOnJS(() => { isAnimatingRef.current = false; })();
    });
  }, [height, jsOpenUI]);

  const close = useCallback(() => {
    if (!isOpenRef.current || isAnimatingRef.current) return;

    isAnimatingRef.current = true;

    height.value = withTiming(config.HIDDEN_HEIGHT, config.closeConfig, (finished) => {
      // ✅ only after animation end
      if (finished) runOnJS(jsCloseUI)();
      else runOnJS(() => { isAnimatingRef.current = false; })();
    });
  }, [height, jsCloseUI]);

  const openWith = useCallback(
    (node: React.ReactNode) => {
      // если уже открыт — просто обновим guts
      if (isOpenRef.current) {
        setGuts(node);
        setExpanded(true);
        refBackDrop.current?.setStart(true);
        return;
      }

      // если в процессе анимации закрытия/открытия — просто обновим guts и попробуем открыть
      setGuts(node);
      open();
    },
    [open]
  );

  const openClose = useCallback(
    (node?: React.ReactNode) => {
      // Поведение:
      // - если передан node -> "открыть/обновить"
      // - если node не передан -> "закрыть"
      if (node) {
        openWith(node);
        return;
      }
      close();
    },
    [close, openWith]
  );

  useImperativeHandle(ref, () => ({
    open,
    close,
    setGuts: (node: any) => setGuts(node),
    openClose,
  }));

  const top = heightOfTopNav(isSmallVersion);

  return (
    <Portal>
      {/* Backdrop */}
      <View pointerEvents={expanded ? "auto" : "none"}  // ✅ ключ
      style={[StyleSheet.absoluteFill, { top, left: 0, right: 0 }]}
      >
        <BackDrop ref={refBackDrop} onPress={() => close()} />
      </View>

      {/* Panel */}
      <Animated.View
        pointerEvents={expanded ? "auto" : "none"} // ✅ когда закрыто — не кликается
        style={[
          {
            position: "absolute",
            zIndex: 300,
            left: 0,
            right: 0,
            top,
            backgroundColor: TOP_NAV_COLOR,
            overflow: "hidden", // ✅ чтобы ничего не “торчало”
          },
          animatedStyle,
        ]}
      >
        {expanded && guts}
      </Animated.View>
    </Portal>
  );
});

export default ExpandedMenu;
